import { UserType } from '../../../types'

const initialRegex = new RegExp('([a-z0-9äöüß]+\\. |Prof |Dr )', 'gi')

function strip(value: string) {
  return (
    (value.replace(initialRegex, '').match(/[A-ZÄÖÜ]/) || [])[0] ||
    (value.replace(initialRegex, '').match(/[a-zäöüß]/i) || [])[0] ||
    value[0] ||
    ''
  )
}

function getEmailInitials(emailAddress: UserType['emailAddress']) {
  return emailAddress.slice(0, 2).toUpperCase()
}

export default function initials(user: UserType) {
  const { firstName, lastName, emailAddress } = user

  const hasName = firstName || lastName

  return hasName
    ? `${strip(firstName || '')}${strip(lastName || '')}`.toUpperCase()
    : getEmailInitials(emailAddress)
}
